export default __webpack_public_path__ + "static/media/playIcon-2cec4e6a393520ca5d81bd79d45cceef.png";